module.exports = __webpack_public_path__ + "img/3Dian5_3.61a49e24.png";